<template>
  <div class="full-screen-biz-time">
    <!-- 结构化展示 -->
    <!-- <div
      class="biz-item"
      v-for="(item, index) in value"
      :key="index">
      <div class="show-content">{{item.bizDay | formatBizDay}}</div>
      <div class="show-content">
        <div
          class="segment"
          v-for="(segment, index) in item.bizTime"
          :key="index"
        >{{segment.begin}}-{{segment.end}}</div>
      </div>
    </div>
    <rich-button
      class="btn"
      @click="beginEdit"
      light
    >{{gettext('请选择')}}</rich-button> -->
    <!-- main-page -->
    <page
      ref="mainPage"
      :style="{'z-index': zindex}"
      @submit="saveData"
    >
      <h4>{{gettext('营业时间')}}</h4>
      <div
        v-for="(item, index) in tempData"
        :key="index"
        class="biz-item"
      >
        <div class="show-content">{{item.bizDay | formatBizDay}}</div>
        <div class="show-content">
          <div
            class="segment"
            v-for="(segment, index) in item.bizTime"
            :key="index"
          >{{segment.begin}}-{{segment.end}}</div>
        </div>
        <div
          v-show="!item.bizDay.length || !item.bizTime.length"
          class="show-content"
        >{{gettext('添加营业时间')}}<i class="richic-important"></i></div>
        <div class="action-wrap">
          <rich-button inline light @click="beginEditItem(index)">{{gettext('编辑')}}</rich-button>
          <rich-button inline light @click="removeItem(index)">{{gettext('删除')}}</rich-button>
        </div>
      </div>
      <rich-button
        light
        v-show="tempData.length < 5"
        @click="addItem"
        icon="richic-add"
      >{{gettext('添加营业时间')}}</rich-button>
    </page>
    <!-- item-page -->
    <page
      v-if="!isEmpty(tempDayTime)"
      ref="itemPage"
      :style="{'z-index': zindex}"
      @submit="saveDayTime"
    >
        <h4>{{gettext('添加营业时间')}}</h4>
        <!-- 营业天数 -->
        <h5>{{gettext('请选择营业天数')}}</h5>
        <multi-select
          v-model="tempDayTime.bizDay"
          :options="BIZDAY_OPTIONS"
          :zindex="zindex + 1"
        ></multi-select>
        <!-- 多个营业时间段 -->
        <h5>{{gettext('营业时间段')}}</h5>
        <div
          v-for="(item, index) in tempDayTime.bizTime"
          :key="index"
          class="segment-edit"
        >
          <span>{{item.begin}}-{{item.end}}</span>
          <rich-button
            outline
            primary
            inline
            @click="removeSegmentTime(index)"
          >
            <i class="richic-delete"></i>
          </rich-button>
        </div>
        <rich-button
          light
          v-show="tempDayTime.bizTime.length < 5"
          @click="addSegmentTime"
          icon="richic-add"
        >{{gettext('添加营业时间段')}}</rich-button>
    </page>
  </div>
</template>

<script type="text/ecmascript-6">
import { cloneDeep, isEmpty } from 'lodash-es'
import Page from './Page'
import MultiSelect from './MultiSelect'
import { BIZDAY_OPTIONS } from '@/consts'

// 小时 00-23
const HOUR_OPTIONS = (function (count) {
  let i = 0
  let res = []
  while (i < count) {
    let val = i < 10
      ? `0${i}`
      : `${i}`
    res.push({
      text: val,
      value: val
    })
    i++
  }
  return res
})(24)
// 分钟step=10 00-50
const MINUTES_OPTIONS = (function (count) {
  let i = 0
  let res = []
  while (i < count) {
    let val = i < 10
      ? `0${i}`
      : `${i}`
    res.push({
      text: val,
      value: val
    })
    i += 10
  }
  return res
})(59)
export default {
  name: 'fullScreenBizTime',
  components: {
    Page,
    MultiSelect
  },
  props: {
    zindex: {
      type: Number,
      default: 10
    },
    value: {
      type: Array,
      required: true,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      tempData: cloneDeep(this.value),
      tempIndex: 0,
      tempDayTime: {
        bizTime: [],
        bizDay: []
      },
      tempBizDays: [],
      BIZDAY_OPTIONS
    }
  },
  computed: {},
  methods: {
    isEmpty,
    // beginEdit () {
    //   this.$refs.mainPage.show()
    // },
    show () {
      this.$refs.mainPage.show()
    },
    saveData (next) {
      for (let i of this.tempData) {
        let { bizTime, bizDay } = i
        if (!bizTime.length || !bizDay.length) {
          this.$createToast({
            type: 'warn',
            txt: this.gettext('请补全营业时间'),
            time: 1000
          }).show()
          return
        }
      }
      this.$emit('confirm', cloneDeep(this.tempData))
      this.$emit('input', cloneDeep(this.tempData))
      next()
    },
    addItem () {
      this.tempData.push({
        bizTime: [],
        bizDay: []
      })
      this.beginEditItem(this.tempData.length - 1)
    },
    beginEditItem (index) {
      this.tempIndex = index
      this.tempDayTime = cloneDeep(this.tempData[index])
      this.$refs.itemPage.show()
    },
    removeItem (index) {
      this.tempData.splice(index, 1)
    },
    saveDayTime (next) {
      // validate
      const { bizDay, bizTime } = this.tempDayTime
      if (!bizDay.length) {
        this.$createToast({
          type: 'warn',
          txt: this.gettext('请选择营业天数'),
          time: 1000
        }).show()
      } else if (!bizTime.length) {
        this.$createToast({
          type: 'warn',
          txt: this.gettext('添加营业时间段'),
          time: 1000
        }).show()
      } else {
        this.$set(this.tempData, this.tempIndex, this.tempDayTime)
        next()
      }
    },
    addSegmentTime () {
      // http://rlab-fe.xiaojukeji.com/rich-ui/#/zh-CN/docs/segment-picker
      let segmentData = [
        {
          is: 'rich-picker',
          title: this.gettext('开始时间'),
          data: [HOUR_OPTIONS, MINUTES_OPTIONS]
        },
        {
          is: 'rich-picker',
          title: this.gettext('结束时间'),
          data: [HOUR_OPTIONS, MINUTES_OPTIONS]
        }
      ]
      this.$createSegmentPicker({
        data: segmentData,
        onSelect: (selectedDates, selectedVals, selectedTexts) => {
          // console.log(selectedDates, selectedVals, selectedTexts)
          this.tempDayTime.bizTime.push({
            begin: selectedDates[0].join(':'),
            end: selectedDates[1].join(':')
          })
        },
        onNext: (i, selectedDate, selectedValue, selectedText) => {}
      }).show()
    },
    removeSegmentTime (index) {
      this.tempDayTime.bizTime.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.full-screen-biz-time {
  color: $color-grey;
  .btn {
      font-size: $fontsize-medium;
    }
  .biz-item {
    margin-bottom: 10px;
    .show-content {
      margin-bottom: 12px;
      overflow: auto;
      font-size: $fontsize-medium;
      .segment {
        margin-right: 20px;
      }
    }
    .action-wrap {
      text-align: right;
    }
  }
  h4 {
    font-size: $fontsize-large;
    margin-bottom: 20px;
  }
  h5 {
    font-size: $fontsize-medium;
    margin-bottom: 10px;
  }
  .richic-delete {
    margin-right: 0;
  }
  .segment-edit {
    text-align: center;
    margin-bottom: 16px;
    line-height: 32Px;
    font-size: $fontsize-medium;
    span {
      margin-right: 20px;
    }
  }
}
</style>
